import Select from "react-select";

import { AbconetApi } from "./AbconetApi";
import SiteBudgetData from "./SiteBudgetData";
import { SiteEdit } from '../Site/SiteEdit';

const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) };

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { isNullOrUndefined } from "util";
import ReactTooltip from 'react-tooltip'
import { getStockInfo, getEta } from "../Cart/CartFunctions";
import moment from "moment";

var formatMoney = require('../General/Helper').formatMoney;

var authorityToLeaveOptions = [
    {
        text: "",
        id: ""
    },
    {
        text: "A secure place",
        id: 1
    },
    {
        text: "Front door",
        id: 2
    },
    {
        text: "Back door",
        id: 3
    },
    {
        text: "Inside garage",
        id: 4
    },
    {
        text: "On front veranda/porch",
        id: 5
    },
    {
        text: "Behind side gate",
        id: 6
    }
];

class DeliverySelectorPickup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            addressCollection: []
        };
    }

    componentDidMount() {
        var self = this;
        fetch('/api/address/pickuplist').then(response => {
            return response.json();
        }).then(data => {
            self.setState({
                addressCollection: data
            });
        });
    }

    renderAddress() {
        if (this.props.hideSummary) {
            return;
        }

        if (this.props.value == null) {
            return <div className="p-3 card">No address currently selected.</div>;
        }

        return <div className="p-3 card">
            <div>{this.props.value.addressLine1}</div>
            <div>{this.props.value.addressLine2}</div>
            <div>{this.props.value.suburb} {this.props.value.state} {this.props.value.postcode}</div>
            <div>{this.props.value.addressLine3}</div>
            <div>{this.props.value.addressLine4}</div>
            <div>{this.props.value.addressLine5}</div>
        </div>;
    }

    render() {
        return <div>
            <Select className="select-inline type-month"
                value={this.props.value}
                onChange={this.props.onChange}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                styles={selectStyles}
                options={this.state.addressCollection} />
            {/*{this.renderAddress()}*/}
           
        </div>;
    }
}



class LocationSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            addressCollection: [],
            createNewMode: false,
        };
    }

    setCreateNewMode(option) {
        this.setState({ createNewMode: option });
    }

    handleCreateSite(siteId) {
        this.setState({ createNewMode: false });
        this.loadData().then(() => {
            var selectedAddress = this.state.addressCollection.find(x => x.id == siteId);
            this.props.onChange(selectedAddress);
        });
    }

    loadData() {
        return AbconetApi.get('/api/address').then(data => {
            this.setState({
                addressCollection: data.list
            });
        });
    }

    componentDidMount() {
        this.loadData();
    }

    renderAddress() {
        if (this.props.hideSummary) {
            return;
        }

        if (this.props.value == null) {
            return <div className="p-3 card">No address currently selected.</div>;
        }

        var addressLine1 = "";
        if (this.props.value.addressLine1 !== this.props.value.name) {
            addressLine1 = this.props.value.addressLine1;
        }

        var showBudget;
        if (this.props.showBudget) {
            showBudget = <SiteBudgetData cart={this.props.cart} hidePrices={this.props.hidePrices} />;
        }

        return <div className="p-3 card">
            <div>{this.props.value.name}</div>
            <div>{addressLine1}</div>
            <div>{this.props.value.addressLine2}</div>
            <div>{this.props.value.suburb} {this.props.value.state} {this.props.value.postcode}</div>
            <div>{this.props.value.addressLine3}</div>
            <div>{this.props.value.addressLine4}</div>
            <div>{this.props.value.addressLine5}</div>
            {showBudget}
        </div>;
    }

    renderCreateNew() {
        return (<SiteEdit initialSite={{ id: 0 }} miniMode={true} onCreateSite={this.handleCreateSite.bind(this)} onCancel={this.setCreateNewMode.bind(this, null)} />);
    }

    render() {
        if (this.state.createNewMode) {
            return this.renderCreateNew();
        }

        var padding = "mt-2";
        if (this.props.extraButton) {
            padding = "mt-4";
        }

        return <div>
            {!this.props.readOnly && <Select isClearable className="select-inline type-month"
                value={this.props.value}
                onChange={this.props.onChange}
                getOptionLabel={(option) => option.fullAddress}
                getOptionValue={(option) => option.id}
                styles={selectStyles}
                options={this.state.addressCollection} />}
            {this.props.showCreateNew && <button className={"btn btn-secondary " + padding} onClick={this.setCreateNewMode.bind(this)}>Create new site</button>}
            {this.props.extraButton}
            {this.renderAddress()}
        </div>;
    }
}

class OwnCourier extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            addNewOpen: false,
            ownCouierCollection: [],
            currentSelectedCourier: this.props.cart.ownCourier,
            courierAccountNumber: "",
            courierName: ""
        };
    }

    updateCourierAccountNumber(ev) {
        this.setState({ courierAccountNumber: ev.target.value });
    }

    updateCourierName(ev) {
        this.setState({ courierName: ev.target.value });
    }

    addNewCourier() {
        AbconetApi.post(`/api/address/owncourier/`, {
            freightCompanyName: this.state.courierName,
            freightAccountNumber: this.state.courierAccountNumber
        }
        ).then(returnObj => {
                var data = this.state.ownCouierCollection;
                data.push(returnObj);
            this.setState({ ownCouierCollection: data, currentSelectedCourier: returnObj, addNewOpen: false });
            this.props.onChange(returnObj);
            }
        );
    }

    componentDidMount() {
        this.loadOwnCourierOptions();
    }

    updateSelectedCourier(data) {
        this.setState({
            currentSelectedCourier: data
        });

        this.props.onChange(data);

    }

    getColWidthClass() {
        if (this.props.oneColumn) {
            return "col-12";
        }
        return "col-12 col-lg-6";
    }

    loadOwnCourierOptions() {
        AbconetApi.get(`/api/address/owncourier`).then(data => {
            this.setState(
                {
                    ownCouierCollection: data
                }
            );

            if (this.state.currentSelectedCourier == null && data.length > 0) {
                this.setState({
                    currentSelectedCourier: data[0]
                });

                this.props.onChange(data[0]);
            }
        });
    }

    renderAddNewCourier() {
        return <div><div className="row">
            <div className={this.getColWidthClass()}>
                Courier name
            </div>
            <div className={this.getColWidthClass()}>
                <input type="text" value={this.state.courierName} className="form-control" id="courierName" onChange={this.updateCourierName.bind(this)} />
            </div>
        </div>
            <div className="row pt-3">
                <div className={this.getColWidthClass()}>
                    Courier account number
                </div>
                <div className={this.getColWidthClass()}>
                    <input type="text" value={this.state.courierAccountNumber} className="form-control" id="courierAccountNumber" onChange={this.updateCourierAccountNumber.bind(this)} />
                </div>
            </div>
            <div className="row">
                <br />
            </div>
            <div className="row">
                <div className="col-12">
                    <button className="btn btn-secondary ml-2 float-right" onClick={this.addNewCourier.bind(this)}>Add</button>
                    {this.state.ownCouierCollection.length > 0 && <button className="btn btn-outline-secondary float-right" onClick={this.closeAddNew.bind(this)}>Cancel</button>}
                </div>
            </div>
        </div>;
    }

    renderSelector() {
        return <div>
            <div className="row">
                <div className="col-1"></div>
                <div className="col-5">
                    <Select className="select-inline type-month"
                        getOptionLabel={(option) => <span>{option.freightCompanyName} - {option.freightAccountNumber}</span>}
                        getOptionValue={(option) => option.id}
                        value={this.state.currentSelectedCourier}
                        options={this.state.ownCouierCollection}
                        onChange={this.updateSelectedCourier.bind(this)}
                    />
                </div>
                <div className="col-2 text-center">or</div>
                <div className="col-4">
                    <button className="btn btn-outline-secondary" onClick={this.openAddNew.bind(this)}>Add New</button>
                </div>
            </div>
        </div>;
    }

    openAddNew() {
        this.setState({ addNewOpen: true });
    }

    closeAddNew() {
        this.setState({ addNewOpen: false });
    }

    render() {
        if (this.state.addNewOpen || this.state.ownCouierCollection.length == 0) {
            return this.renderAddNewCourier();
        }

        return this.renderSelector();
    }
}

export class DeliveryOption extends React.Component {
    constructor(props) {
        super(props);

        var instructions = this.props.cart.deliveryInstructions;
        if (instructions == null && this.props.cart.address) {
            instructions = this.props.cart.address.note;
        }

        var contactName = this.props.cart.contactName;
        if (contactName == null && this.props.cart.address) {
            contactName = this.props.cart.address.siteContactName;
        }

        var contactNumber = this.props.cart.contactNumber;
        if (contactNumber == null && this.props.cart.address) {
            contactNumber = this.props.cart.address.siteContactPhone;
        }

        this.state = {
            deliveryType: this.getDeliveryTypeFromCart(),
            deliveryInstructions: instructions,
            secureLocation: this.props.cart.secureLocation,
            ownCourier: null,
            deliveryAddress: this.props.cart.address,
            pickupLocation: null,
            multipleDeliveries: this.props.cart.multipleDeliveries,
            shippingType: this.props.cart.shippingType,
            contactName: contactName,
            contactNumber: contactNumber,
            isSubmitting: false,
            isShippingError: false
        };

        if (this.props.showDeliveryInstructions) {
            this.props.updateContactName(contactName);
            this.props.updateContactNumber(contactNumber);
            this.props.updateDeliveryInstructionsChange(instructions);
        }
    }

    saveDeliveryInstructionsToSite() {
        var address = this.props.cart.address;
        address.note = this.state.deliveryInstructions;
        AbconetApi.post(`/api/address/`, address).then(address => {

        });
    }

    updateInstructions(ev) {
        this.setState({
            deliveryInstructions: ev.target.value
        }, () => {

            this.setDeliveryOptions()
        });

    }

    validateLength(e, length) {
        if (e.target.value.length > length) {
            e.target.value = e.target.value.slice(0, length)
        } else {
            e.target.value;
        }
    }


    updateDeliveryInstructions(ev) {
        this.setState({ deliveryInstructions: ev.target.value });
        this.props.updateDeliveryInstructionsChange(ev.target.value);
    }

    updatePurchaseOrderNumber(ev) {
        if (ev.target.value.length <= 20) {
            this.setState({ purchaseOrderNumber: ev.target.value });
            this.props.updatePurchaseOrderNumberOnChange(ev);
        }
    }

    updateContactName(ev) {
        this.setState({ contactName: ev.target.value })
        this.props.updateContactName(ev.target.value);
    }

    updateContactNumber(ev) {
        this.setState({ contactNumber: ev.target.value })
        this.props.updateContactNumber(ev.target.value);
    }

    updateAuthorityToLeave(ev) {
        this.setState({
            secureLocation: ev.id
        }, () => {

            this.setDeliveryOptions()
        });
    }

    getDeliveryTypeFromCart() {
        if (this.props.cart.pickupLocation != null) {
            return "PICK-UP";
        }

        if (this.props.cart.ownCourier != null) {
            return "OWN-COURIER"
        }

        return "NORMAL";
    }

    setDeliveryType(index) {

        var value = "NORMAL";

        if (index === 1) {
            value = "PICK-UP";
        } else {
            if (index === 2) {
                value = "OWN-COURIER";
                this.setState({ deliveryType: value, pickupLocation: null });
                return;
            }
            else {
                this.setState({ deliveryType: value, pickupLocation: null }, () => { this.setDeliveryOptions() });
            }
        }

        this.setState({ deliveryType: value }, () => this.props.updateDeliveryType(value));
        this.props.multipleDeliveries(false);
    }

    changeDeliveryOption(option) {
        this.setState({ deliveryType: option.value });
    }

    setDeliveryOptions() {
        this.props.onChange({
            deliveryType: this.state.deliveryType,
            address: this.state.deliveryAddress,
            pickupLocation: this.state.pickupLocation,
            secureLocation: this.state.secureLocation,
            ownCourier: this.state.ownCourier
        });
    }

    updateAddress(selectedAddress) {
        this.setState({ deliveryAddress: selectedAddress }, () => { this.setDeliveryOptions() });
    }

    updatePickupLocation(selectedAddress) {
        this.setState({ pickupLocation: selectedAddress }, () => { this.setDeliveryOptions() });
    }

    updateOwnCourier(selectedCourier) {
        this.setState({ ownCourier: selectedCourier }, () => { this.setDeliveryOptions() });
    }

    getColWidthClass() {
        if (this.props.oneColumn) {
            return "col-12";
        }
        return "col-12 col-lg-6";
    }

    renderPurchaseOrderField() {
        if (!this.props.showPurchaseOrderNumber) {
            return null;
        }
        var optional = <div className="optional">(optional)</div>;
        if (this.props.cart.requiresOrderNumber) {
            optional = "";
        }
        return <div className="row">
            <div className={this.getColWidthClass()}>
                Purchase Order Number
                     {optional}
            </div>
            <div className={this.getColWidthClass()}>
                <input type="text" className="form-control" id="purchaseOrderNumber" value={this.props.cart.purchaseOrderNumber} onChange={this.updatePurchaseOrderNumber.bind(this)} />
            </div>
        </div>;

    }

    onMultipleDeliveriesChange(ev) {
        console.log('onMultipleDeliveriesChange', ev);
        this.setState({ multipleDeliveries: ev.target.value });
        this.props.multipleDeliveries(ev.target.value);
    }

    updateShippingType(ev) {
        console.log('updateShippingType', { value: ev.target.value, ev });
        let shippingType = ev.target.value;

        this.setState({ isSubmitting: true })
        this.props.updateShippingTypeChange(shippingType)
            .then(() => {
                this.setState({ isSubmitting: false })
            })
            .catch(error => {
                this.setState({ isShippingError: true });
                this.setState({ isSubmitting: false })
            });
        
    }

    updateIsSubmitting(value, callback) {
        this.setState({ isSubmitting: value }, () => {
            if (typeof callback === 'function') {
                callback();
            }
        });
    }

    renderShippingType() {
        if (this.props.cart.address == null) {
            return null;
        }

        if (this.props.cart.address && this.props.cart.address.id !== 0) {

            var normal = false;
            var urgent = false;
            var fastest = false;

            if (!this.props.cart.shippingType || this.props.cart.shippingType === 'NORMAL') {
                normal = true;
            } else if (this.props.cart.shippingType === 'URGENT') {
                urgent = true;
            } else if (this.props.cart.shippingType === 'FASTEST') {
                fastest = true;
            }

            var disableOtherShipping = false;
            var otherShippingMessage;
            if (this.props.cart.address.region !== '1') {
                return null;
            }

            return <div className="row mb-1">
                <div className="col-12">
                    <h6>Select shipping option <i id="shipping-info" className="icon icon-info" data-tip="Dispatch times are contingent upon business hours, order placement, and item availability. Approximate dispatch times are as follows: Normal: 24 hours, Urgent: 4 hours, Fastest: 2 hours."></i> <ReactTooltip /> </h6>
                </div>
                <div className="col-12 custom-control custom-radio ml-3" onChange={this.updateShippingType.bind(this)}>
                    <div className="row">
                        <div className="col-3 text-left">
                            <input type="radio" name="shippingType" id="normal" value="NORMAL" className="custom-control-input" defaultChecked={normal} disabled={this.state.isSubmitting} checked={normal || this.state.isShippingError} />
                            <label className="custom-control-label" htmlFor="normal" normal>Normal</label>
                        </div>

                        <div className="col-3 text-left">
                            <input type="radio" name="shippingType" id="urgent" value="URGENT" className="custom-control-input" defaultChecked={urgent} disabled={disableOtherShipping || this.state.isSubmitting || this.state.isShippingError} />
                            <label className="custom-control-label" htmlFor="urgent">Urgent {otherShippingMessage}</label>
                            
                        </div>

                        <div className="col-3 text-left">
                            <input type="radio" name="shippingType" id="fastest" value="FASTEST" className="custom-control-input" defaultChecked={fastest} disabled={disableOtherShipping || this.state.isSubmitting || this.state.isShippingError} />                            <label className="custom-control-label" htmlFor="fastest">Fastest Possible {otherShippingMessage}</label>
                        </div>

                        <div className="col-3">

                        </div>
                        {this.state.isSubmitting && (
                            <div className="col-9 text-left mt-2 alt-row pt-1 pb-1 border">
                                <div className="d-flex">
                                    <span>Securing delivery rates</span>
                                    <div className="div-spinner ml-2" style={{ borderTopColor: '#007bff', borderLeftColor: '#007bff' }}></div>
                                </div>
                            </div>
                        )}
                    </div>
                    
                    <hr className="ml-n4" />
                </div>
            </div>
            
        }
    }

    renderDeliveryTabOption() {
        var deliveryInstructions = null;
        var authorityToLeave = null;
        var manageSites = null;
        if (this.props.showDeliveryInstructions) {
            deliveryInstructions = <div> <div className="row pt-3">
                <div className={this.getColWidthClass()}>
                    Delivery instructions
                    <div className="optional">(optional)</div>
                </div>
                <div className={this.getColWidthClass()}>
                    <textarea value={this.state.deliveryInstructions} className="form-control" onChange={this.updateDeliveryInstructions.bind(this)} onInput={(e) => this.validateLength(e, 255)} />
                    {/*{this.props.cart.address && <button className="btn btn-link" onClick={this.saveDeliveryInstructionsToSite.bind(this)}>Save instructions for future orders</button>}*/}
                </div>
            </div>

                <div className="row pt-3">
                    <div className={this.getColWidthClass()}>
                        Contact Name
                    </div>

                    <div className={this.getColWidthClass()}>
                        <input type="text" className="form-control" id="contactName" value={this.state.contactName} onChange={this.updateContactName.bind(this)} />
                    </div>
                    <br /> <br />
                    <div className={this.getColWidthClass()}>
                        Contact Number
                    </div>

                    <div className={this.getColWidthClass()}>
                        <input type="text" className="form-control" id="contactNumber" value={this.state.contactNumber} onChange={this.updateContactNumber.bind(this)} />
                    </div>

                </div>
            </div>;
        }

        if (this.props.showAuthorityToLeave) {
            authorityToLeave = <div className="delivery-instructions">
                <div><strong>Authority to leave</strong></div>
                <Select className="select-inline"
                    getOptionLabel={(option) => option.text}
                    getOptionValue={(option) => option.id}
                    styles={selectStyles}
                    options={authorityToLeaveOptions}
                    value={authorityToLeaveOptions.find(x => x.id == this.state.secureLocation)}
                    onChange={this.updateAuthorityToLeave.bind(this)}
                />
            </div>;

            authorityToLeave = null;
        }

        if (this.props.showManageSites) {
            manageSites = <a className="manage-sites-link" href="/sites/">Manage sites</a>;
        }        

        var eta = getEta(this.props.cart);

        var freightCost = this.props.cart.freightCost;
        if (this.props.cart.multipleDeliveries) {
            freightCost = freightCost / 2;
        }
        
        return (
        
            <div className="manage-sites-picker">

                {this.props.showMultipleDeliveries && <div>
                    <div className="row">
                        <div className="col-12">
                            <h6> How would you like your items delivered? <i className="icon icon-info" data-tip="Dispatch date is estimated only. Unforseen circumstances may affect your driver's journey. It is our priority to deliver your order safe."></i> <ReactTooltip /> </h6>
                        </div>
                        <div className="col-12" onChange={this.onMultipleDeliveriesChange.bind(this)}>
                            
                            <label htmlFor="singleDelivery" className="col-12" style={{"paddingLeft": "0px"}}>
                                <input style={{"marginRight": "12px"}} name="multipleDeliveries" type="radio"
                                    id="singleDelivery"
                                    value="false"
                                    defaultChecked={!this.state.multipleDeliveries}
                                />
                                <strong>Single dispatch {eta.singleDispatch}</strong>
                                <br />
                                <span style={{ "marginLeft": "4%" }}>
                                    Your order will be dispatched in a single delivery when all items are available.
                                </span>
                            </label>
                            
                            <label htmlFor="multipleDeliveries" className="col-12" style={{ "paddingLeft": "0px" }}>
                                <input style={{ "marginRight": "12px" }} name="multipleDeliveries" type="radio"
                                    id="multipleDeliveries"
                                    value="true"                                    
                                    defaultChecked={this.state.multipleDeliveries} />
                                <strong>Multiple dispatch {eta.multipleDispatch}</strong>
                                <br />
                                <span style={{ "marginLeft": "4%" }}>
                                    Your order will be dispatched in multiple deliveries.
                                </span>
                            </label>
                            <hr />
                        </div>
                    </div>
                </div>
                }
                <div className="row">
                    <div className="col-12">

                        {!this.props.oneColumn && this.renderShippingType()}
                        {!this.props.readOnly && manageSites}
                        {!this.props.oneColumn && <h6>Order will be delivered to:</h6>}
                    </div>
                    <div className="col-12">

                        <LocationSelector isClearable onChange={this.updateAddress.bind(this)} value={this.props.cart.address}
                            showCreateNew={this.props.showCreateNew}
                            extraButton={this.props.extraButton}
                            hideSummary={this.props.hideSummary}
                            showAuthorityToLeave={this.props.showAuthorityToLeave}
                            readOnly={this.props.readOnly}
                            showBudget={this.props.showBudget}
                            hidePrices={this.props.hidePrices}
                            cart={this.props.cart} />
                    </div>
                </div>

                {this.renderPurchaseOrderField()}
                {!this.props.readOnly && deliveryInstructions}
                {!this.props.readOnly && authorityToLeave}
            </div>
        );
    }

    renderPickupTabOption() {
        var editor;
        if (!this.props.readOnly) {
            editor = (
                <div className="row">
                    {!this.props.oneColumn && <div className="col-12"><h6>Order can be picked up from:</h6></div>}
                    <div className="col-12">
                        <DeliverySelectorPickup onChange={this.updatePickupLocation.bind(this)} value={this.props.cart.pickupLocation} hideSummary={this.props.hideSummary} hidePrices={this.props.hidePrices} />
                    </div>
                 
                    <div className="col-12">
                        <br />
                        <strong> For site:
                            <i className="icon icon-rechargeable" data-tip=""></i> <ReactTooltip />
                        </strong>
                        <LocationSelector isClearable onChange={this.updateAddress.bind(this)} value={this.props.cart.address}
                            showCreateNew={this.props.showCreateNew}
                            extraButton={this.props.extraButton}
                            hideSummary={this.props.hideSummary}
                            showAuthorityToLeave={this.props.showAuthorityToLeave}
                            readOnly={this.props.readOnly}
                            showBudget={this.props.showBudget}
                            hidePrices={this.props.hidePrices}
                            cart={this.props.cart} />
                    </div>
                </div>
            );
        }

        return <div>
            {editor}
            <br />
            {this.renderPurchaseOrderField()}
      
        </div>;
    }

    renderDeliverySelector() {
        var deliverySelector = null;

        var purchaseOrderField = null;
        if (this.props.showPurchaseOrderNumber) {
            purchaseOrderField = <div className="row">
                <div className={this.getColWidthClass()}>
                    <strong>Purchase Order Number</strong>
                </div>
                <div className={this.getColWidthClass()}>
                    <input type="text" className="formcontrol colsm4" id="purchaseOrderNumber" value={this.props.cart.purchaseOrderNumber} onChange={this.updatePurchaseOrderNumber.bind(this)} />
                </div>
            </div>;
        }

        if (this.state.deliveryType == "PICKUP") {
            var orderSite;

            if (this.props.cart.address) {
                var name = this.props.cart.address.name;


                orderSite = <div className="mt3">
                    <h6>For Site:</h6>
                    {name}
                </div>;
            }

            var editor;
            if (!this.props.readOnly) {
                editor = (
                    <div className="row">
                        <div className={this.getColWidthClass()}>
                            <h6>Order can be picked up from:</h6>
                        </div>
                        <div className={this.getColWidthClass()}>
                            <DeliverySelectorPickup onChange={this.updateAddress.bind(this)} value={this.props.cart.pickupLocation} hideSummary={this.props.hideSummary} />
                        </div>
                    </div>
                );
            }


            return <div>
                {editor}
                {purchaseOrderField}
                {orderSite}
            </div>;
        } else {
            var deliveryInstructions = null;
            var authorityToLeave = null;
            var manageSites = null;
            if (this.props.showDeliveryInstructions) {
                deliveryInstructions = <div className="deliveryinstructions">
                    <div><strong>Delivery instructions</strong>
                        {/*{this.props.cart.address && <button className="btn btnlink" onClick={this.saveDeliveryInstructionsToSite.bind(this)}>Save instructions for future orders</button>}*/}
                            </div>
                    <textarea value={this.state.deliveryInstructions} className="formcontrol" onChange={this.updateDeliveryInstructions.bind(this)} />
                </div>;
            }

            if (this.props.showAuthorityToLeave) {
                authorityToLeave = <div className="deliveryinstructions">
                    <div><strong>Authority to leave</strong></div>
                    <Select className="selectinline"
                        getOptionLabel={(option) => option.text}
                        getOptionValue={(option) => option.id}
                        styles={selectStyles}
                        options={authorityToLeaveOptions}
                        value={authorityToLeaveOptions.find(x => x.id == this.state.secureLocation)}
                        onChange={this.updateAuthorityToLeave.bind(this)}
                    />
                </div>;

                authorityToLeave = null;
            }

            if (this.props.showManageSites) {
                manageSites = <a className="managesiteslink" href="/sites/">Manage sites</a>;
            }

            return (
                <div className="managesitespicker">
                    <div className="row">
                        <div className={this.getColWidthClass()}>
                            {!this.props.readOnly && manageSites}
                            <h6>Order will be delivered to:</h6>
                        </div>
                        <div className={this.getColWidthClass()}>

                            <LocationSelector isClearable
                                onChange={this.updateAddress.bind(this)}
                                value={this.props.cart.address}
                                hideSummary={this.props.hideSummary}
                                showAuthorityToLeave={this.props.showAuthorityToLeave}
                                readOnly={this.props.readOnly}
                                showBudget={this.props.showBudget}
                                hidePrices={this.props.hidePrices}
                                cart={this.props.cart} />
                        </div>
                    </div>

                    {purchaseOrderField}
                    {!this.props.readOnly && deliveryInstructions}
                    {!this.props.readOnly && authorityToLeave}
                </div>
            );
        }
    }

    render() {

        if (this.props.readOnly) {
            return this.renderDeliverySelector();
        }
        else {

            var options = [
                {
                    value: "NORMAL",
                    label: "Delivery"
                },
                {
                    value: "PICK-UP",
                    label: "Pick up"
                }
            ];

            if (this.props.oneColumn) {
                return <div>
                    {options.length > 1 && <Select options={options} onChange={this.changeDeliveryOption.bind(this)} value={options.find(x => x.value === this.state.deliveryType)} />}
                    {(this.state.deliveryType === "NORMAL" || this.state.deliveryType === "URGENT" || this.state.deliveryType === "FASTEST") && this.renderDeliveryTabOption()}
                    {this.state.deliveryType === "PICK-UP" && this.renderPickupTabOption()}
                </div>;
            }

            var defaultIndex = 0;
            if (this.state.deliveryType == "PICK-UP") {
                defaultIndex = 1;
            }
            if (this.state.deliveryType == "OWN-COURIER") {
                defaultIndex = 2;
            }

            return <Tabs className="icon-tabs" onSelect={this.setDeliveryType.bind(this)} defaultIndex={defaultIndex}>
                <TabList>
                    <Tab><i className="icon icon-delivery lead"></i>Delivery</Tab>
                    <Tab><i className="icon icon-warehouse lead"></i>Pick up</Tab>
                    {this.props.cart.allowOwnCarrier && <Tab><i className="icon icon-courier lead"></i>Own Courier</Tab>}
                </TabList>
                <TabPanel>
                    {this.renderDeliveryTabOption()}
                </TabPanel>
                {<TabPanel>
                    {this.renderPickupTabOption()}
                </TabPanel>}
                {this.props.cart.allowOwnCarrier && <TabPanel><h6>Order will use a courier:</h6><OwnCourier onChange={this.updateOwnCourier.bind(this)} cart={this.props.cart} oneColumn={this.props.oneColumn} /><br />{this.renderDeliveryTabOption()}</TabPanel>}
            </Tabs>;
        }
    }
}